import { Helmet } from "react-helmet-async";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "../Style.css";

function TermsPage() {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | Own Your Money </title>
        <meta
          name="description"
          content="Terms and conditions for Own Your Money's financial coaching services in the United States. Review our service agreements, commitments, and policies."
        />
        <link rel="canonical" href="https://www.ownyourmoney.biz/terms" />
        <meta name="robots" content="noindex, follow" />
        <meta
          property="og:title"
          content="Terms and Conditions | Own Your Money"
        />
        <meta
          property="og:description"
          content="Terms and conditions for Own Your Money's financial coaching services locally in North Carolina and all over the United States. Review our service agreements, commitments, and policies."
        />
        <meta property="og:url" content="https://www.ownyourmoney.biz/terms" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="%PUBLIC_URL%/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="geo.region" content="US-NC" />
        <meta name="geo.country" content="United States" />
        <meta name="geo.placename" content="Holly Springs, NC" />
        <meta name="geo.position" content="35.65;-78.83" />
        <meta name="ICBM" content="35.65, -78.83" />
        <meta name="language" content="en-US" />
      </Helmet>
      <Header />
      <div className="legal-page">
        <div className="legal-header">
          <h1>Own Your Money LLC Terms and Conditions</h1>
          <h2>Effective as of 9/20/2025</h2>
        </div>

        <p>
          By engaging in financial coaching services with Own Your Money, you
          acknowledge and agree to the following terms:
        </p>

        <ul className="disclaimer-list">
          <li>
            <h3>1. Coaching Relationship</h3>
            <p>
              Financial coaching is a collaborative, educational process
              designed to support your personal financial growth. It is not
              therapy, legal advice, investment management, or accounting. Wendy
              Toh is a
              <strong> Certified Personal Financial Wellness Consultant</strong>{" "}
              and financial coach—not a licensed financial advisor, CPA, or
              attorney.
            </p>
          </li>

          <li>
            <h3>2. Personal Responsibility</h3>
            <p>
              You are responsible for your own financial decisions, actions, and
              outcomes. Coaching is intended to provide guidance, tools, and
              emotional support—not to make decisions on your behalf. You agree
              to use your judgment and seek professional advice when
              appropriate.
            </p>
          </li>

          <li>
            <h3>3. Confidentiality</h3>
            <p>
              All personal and financial information shared during coaching
              sessions will be treated with respect and confidentiality.
              However, coaching is not bound by legal confidentiality
              protections such as attorney-client or therapist-client privilege.
            </p>
          </li>

          <li>
            <h3>4. Scope of Services</h3>
            <p>
              <strong>Services may include:</strong>
            </p>
            <ul>
              <li>Financial education and behavior support</li>
              <li>Budgeting and money management tools</li>
              <li>Goal setting and accountability</li>
              <li>Emotional exploration of money beliefs and habits</li>
            </ul>
            <p>
              <strong>Services do not include:</strong>
            </p>
            <ul>
              <li>Investment recommendations</li>
              <li>Tax preparation or advice</li>
              <li>Legal counsel</li>
            </ul>
          </li>

          <li>
            <h3>5. No Guarantees</h3>
            <p>
              While coaching is designed to support positive financial change,
              results vary by individual. Own Your Money does not guarantee
              specific outcomes, income levels, or financial results.
            </p>
          </li>

          <li>
            <h3>6. Payment & Scheduling</h3>
            <p>
              Payment is due prior to the start of your coaching package unless
              otherwise agreed. Sessions must be scheduled in advance and
              rescheduled with at least 24 hours’ notice. Missed sessions may be
              forfeited at the coach’s discretion.
            </p>
          </li>

          <li>
            <h3>7. Consent to Communication</h3>
            <p>
              By participating in coaching, you consent to receive email and
              text communications related to your coaching experience, including
              session reminders, resources, and check-ins.
            </p>
          </li>
        </ul>
      </div>

      <Footer />
    </>
  );
}
export default TermsPage;
